import { Schema } from "@effect/schema";
import { ChainKey } from "../chain";
import { ProtocolKey } from "../protocol";
import { Address, ADDRESS_ZERO } from "../address";
import { WarningConfig } from ".";
import {
  DisplayMarketAsset,
  SKELETON_DISPLAY_MARKET_ASSET,
} from "../market-asset/display-market-asset";
import { DEFAULT_CHAIN_KEY } from "../chain-legacy";
import { DEFAULT_PROTOCOL_KEY } from "../constants";
import { SKELETON_TOKEN_NAME, SKELETON_TOKEN_SYMBOL } from "../token";
import { Usd, USD_ZERO } from "../usd";

export type DisplayMarket = typeof DisplayMarket.Type;
export type DisplayMarketEncoded = typeof DisplayMarket.Encoded;

export const DisplayMarket = Schema.Struct({
  // market meta
  chainKey: ChainKey,
  protocolKey: ProtocolKey,
  marketAddress: Address,
  marketSymbol: Schema.String,
  marketName: Schema.String,
  marketTokenAddress: Address,
  warningConfig: Schema.NullOr(WarningConfig),
  hasUnstableOracle: Schema.Boolean,
  isDeprecated: Schema.Boolean,
  liquidityUsd: Usd,
  tvlUsd: Usd,

  // assets
  baseAsset: DisplayMarketAsset,
  bridgeAssets: Schema.Tuple(
    DisplayMarketAsset,
    Schema.optionalElement(DisplayMarketAsset)
  ),
}).annotations({ identifier: "DisplayMarket" });

export const SKELETON_DISPLAY_MARKET: DisplayMarket = {
  chainKey: DEFAULT_CHAIN_KEY,
  protocolKey: DEFAULT_PROTOCOL_KEY,
  marketAddress: ADDRESS_ZERO,
  marketSymbol: SKELETON_TOKEN_SYMBOL,
  marketName: SKELETON_TOKEN_NAME,
  marketTokenAddress: ADDRESS_ZERO,
  warningConfig: null,
  hasUnstableOracle: false,
  isDeprecated: false,
  liquidityUsd: USD_ZERO,
  tvlUsd: USD_ZERO,

  baseAsset: SKELETON_DISPLAY_MARKET_ASSET,
  bridgeAssets: [SKELETON_DISPLAY_MARKET_ASSET, SKELETON_DISPLAY_MARKET_ASSET],
};
